import React, { useState, useEffect, useRef } from "react";
import { Element } from "react-scroll";
import "./Services.css";

const Services = (props) => {
  const isMobile = props.isMobile || false;
  const [selectedService, setSelectedService] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const modalRef = useRef(null);

  // بيانات الخدمات المحدثة والمصححة
  const servicesData = [
    {
      id: 1,
      title: "خدمات التطوير والاستثمار العقاري",
      description: "حلول متكاملة لتطوير المشاريع العقارية والاستثمار",
      subServices: [
        {
          id: 1,
          title: "التطوير العقاري",
          description:
            "نقوم بتحويل الأراضي غير المستغلة إلى مشاريع استثمارية مربحة، من خلال دراسة الجدوى والتخطيط والتصميم والتنفيذ، لتحقيق أقصى عائد استثماري ممكن.",
          clientBenefits:
            "تحويل الأراضي من أصول غير منتجة إلى مشاريع استثمارية مربحة دون الحاجة إلى خبرة تقنية أو إدارية مكلفة.",
        },
        {
          id: 2,
          title: "التطوير والتشييد للمشاريع",
          description:
            "نقوم بتصميم وتطوير المشاريع السكنية (مثل الشقق والمباني)، والتجارية (مثل المجمعات والمحلات) والصناعية (مثل المستودعات والمصانع) من الفكرة إلى التسليم النهائي.",
          clientBenefits:
            "خدمة متكاملة تشمل التصميم والحصول على التراخيص والبناء والتشطيب مما يوفر وقت وجهد العميل.",
        },
        {
          id: 3,
          title: "إدارة المشاريع العقارية",
          description:
            "إدارة متكاملة لمشاريع التطوير بدءاً من الفكرة ودراسة الجدوى، ومروراً بالإشراف على البناء وانتهاءً بتسليم المشروع للعميل.",
          clientBenefits:
            "ضمان تنفيذ المشروع ضمن الميزانية المحددة والجدول الزمني المخطط له وبأعلى معايير الجودة.",
        },
      ],
      icon: "🏢",
      color: "#2c5aa0",
    },
    {
      id: 2,
      title: "خدمات الاستشارات العقارية المتخصصة",
      description: "استشارات متخصصة في المجالات التطويرية والمالية والتقنية",
      subServices: [
        {
          id: 1,
          title: "الاستشارات التطويرية ودراسات الجدوى",
          description:
            "نقدم تحليل الأسواق ودراسات جدوى متكاملة، وتقديم استشارات حول أفضل الممارسات للبناء , إضافة لتقديم التوصيات الاستراتيجية والفرص الاستثمارية.",
          clientBenefits:
            "الحصول على استشارة مدروسة بناءً على بيانات دقيقة وتقارير مالية متكاملة.",
        },
        {
          id: 2,
          title: "الاستشارات المالية والمحاسبية",
          description:
            "نقدم استشارات في التخطيط المالي، واختيار نماذج التمويل والهياكل الاستثمارية، ومراجعة العقود المالية لضمان الكفاءة والحماية.",
          clientBenefits:
            "تحسين الأداء المالي ورفع كفاءة العمليات، مع ضمان الشفافية والمصداقية المالية.",
        },
        {
          id: 3,
          title: "الاستشارات القانونية والتراخيص",
          description:
            "تقديم الاستشارات القانونية المتخصصة، والمساعدة في الحصول على جميع التراخيص اللازمة للتطوير والبناء.",
          clientBenefits:
            "تجنب المخالفات والمشاكل القانونية وتسهيل إجراءات المشروع مع الجهات الحكومية.",
        },
      ],
      icon: "📊",
      color: "#27ae60",
    },
  ];

  const contactInfo = {
    email: "info@alyousser.com",
    phone: "+963 117087",
    mobile: "+963 950 037 317",
  };

  const handleServiceClick = (service, subService) => {
    setSelectedService({
      mainService: service,
      subService: subService,
    });
    setIsModalOpen(true);
  };

  const handleCloseModal = (e) => {
    if (e) {
      e.stopPropagation();
    }
    setIsModalOpen(false);
    setSelectedService(null);
  };

  const ServiceCard = ({ service, onServiceClick, isMobile }) => {
    return (
      <div
        className="service-card-modern"
        style={{ "--service-color": service.color }}
      >
        <div className="service-card-header-modern">
          <div
            className="service-icon-modern"
            style={{ backgroundColor: service.color }}
          >
            {service.icon}
          </div>
          <div className="service-title-section">
            <h3 className="service-title-modern">{service.title}</h3>
            <p className="service-description-modern">{service.description}</p>
          </div>
        </div>

        <div className="sub-services-container">
          {service.subServices.map((subService, index) => (
            <div
              key={subService.id}
              className="sub-service-item"
              onClick={(e) => {
                e.stopPropagation();
                onServiceClick(service, subService);
              }}
              onKeyPress={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  e.preventDefault();
                  onServiceClick(service, subService);
                }
              }}
              tabIndex={0}
              role="button"
              aria-label={`عرض تفاصيل ${subService.title}`}
            >
              <div className="sub-service-number">{index + 1}</div>
              <div className="sub-service-content">
                <h4 className="sub-service-title">{subService.title}</h4>
                {/* <p className="sub-service-preview">
                  {subService.description.substring(0, 100)}...
                </p> */}
              </div>
              <div className="sub-service-arrow">→</div>
            </div>
          ))}
        </div>
      </div>
    );
  };

  const ServiceDetailModal = ({
    selectedService,
    onClose,
    isMobile,
    contactInfo,
  }) => {
    if (!selectedService) return null;

    const { mainService, subService } = selectedService;

    return (
      <div
        className="service-modal-overlay-modern"
        onClick={onClose}
        ref={modalRef}
      >
        <div
          className="service-modal-modern"
          onClick={(e) => e.stopPropagation()}
          style={{ "--service-color": mainService.color }}
        >
          <div
            className="service-modal-header-modern"
            style={{ backgroundColor: mainService.color }}
          >
            <div className="modal-header-content">
              <div className="modal-icon-title">
                <div className="service-modal-icon-modern">
                  {mainService.icon}
                </div>
                <div>
                  <h2>{subService.title}</h2>
                  <p className="modal-subtitle">{mainService.title}</p>
                </div>
              </div>
              <button
                className="close-modal-modern"
                onClick={onClose}
                aria-label="إغلاق النافذة"
              >
                <span>×</span>
              </button>
            </div>
          </div>

          <div className="service-modal-body-modern">
            <div className="service-detail-section">
              <div className="section-title-modern">
                <div className="title-icon">📋</div>
                <h3>الوصف التفصيلي</h3>
              </div>
              <div className="detail-card-modern">
                <p className="detail-description">{subService.description}</p>
              </div>
            </div>

            <div className="service-detail-section">
              <div className="section-title-modern">
                <div className="title-icon">✅</div>
                <h3>المنفعة للعميل</h3>
              </div>
              <div className="benefits-card-modern">
                <div className="benefits-icon">✨</div>
                <p className="benefits-text-modern">
                  {subService.clientBenefits}
                </p>
              </div>
            </div>
          </div>

          <div className="service-modal-footer-modern">
            <div className="contact-info-modern">
              <h4>للتواصل والحصول على الخدمة:</h4>
              <div className="contact-details">
                <div className="contact-item">
                  <span>{contactInfo.email}</span>
                  <span className="contact-icon">
                    <i className="bx bxs-envelope"></i>
                  </span>
                </div>
                <div className="contact-item">
                  <span style={{direction:"ltr"}}>{contactInfo.mobile}</span>
                  <span className="contact-icon">
                    <i className="bx bxs-phone"></i>
                  </span>
                </div>
              </div>
            </div>
            <div style={{direction:"rtl"}} className="modal-actions">
              {/* <button
                className="primary-btn-modern"
                style={{ backgroundColor: mainService.color }}
              >
                طلب خدمة استشارية
              </button> */}
              <button className="secondary-btn-modern" onClick={onClose}>
                إغلاق
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <Element name="Services">
      <section className="Services-modern">
        <div className="services-container-modern">
          {/* Sidebar Section */}
          <div className="Services-right">
            <p>05</p>
            <span></span>
            <label>خدماتنا</label>
          </div>

          {/* Main Content */}
          <div className="Services-left">
            {/* Header Section */}
            <div className="services-header-modern">
              <div className="header-content">
                <p className="subtitle-modern">
                  حلول متكاملة في التطوير والاستثمار العقاري والاستشارات
                  المتخصصة تواكب أحدث المعايير العالمية
                </p>
                <div className="header-stats">
                  <div className="stat-item">
                    <div className="stat-number">+50</div>
                    <div className="stat-label">مشروع مكتمل</div>
                  </div>
                  <div className="stat-item">
                    <div className="stat-number">+15</div>
                    <div className="stat-label">سنة خبرة</div>
                  </div>
                  <div className="stat-item">
                    <div className="stat-number">100%</div>
                    <div className="stat-label">رضا العملاء</div>
                  </div>
                </div>
              </div>
            </div>

            {/* Services Grid */}
            <div className="services-grid-modern">
              {servicesData.map((service) => (
                <ServiceCard
                  key={service.id}
                  service={service}
                  onServiceClick={handleServiceClick}
                  isMobile={isMobile}
                />
              ))}
            </div>

            {/* Contact Banner */}
            <div className="contact-banner-modern">
              <div className="banner-content">
                <div className="banner-text">
                  <h3>مستعد لبدء مشروعك العقاري؟</h3>
                  <p>تواصل معنا الآن للحصول على استشارة مجانية</p>
                </div>
                <div className="banner-contact">
                  <div className="contact-info-banner">
                    <div className="contact-item-banner">
                      <span>{contactInfo.email}</span>
                      <span className="contact-icon-banner">
                        <i className="bx bxs-envelope"></i>
                      </span>
                    </div>
                    <div className="contact-item-banner">
                      <span style={{ direction: "ltr", flex: 1 }}>
                        {contactInfo.mobile}
                      </span>
                      <span className="contact-icon-banner">
                        <i className="bx bxs-phone"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Service Detail Modal */}
        {isModalOpen && (
          <ServiceDetailModal
            selectedService={selectedService}
            onClose={handleCloseModal}
            isMobile={isMobile}
            contactInfo={contactInfo}
          />
        )}
      </section>
    </Element>
  );
};

export default Services;
